export const initialShowState = {
    isFetching: false,
};

export const platforms = ['iTunes', 'Spotify', 'Player FM', 'watch OS', 'workperfectly.com', 'Overcast', 'Chrome'];

export const devices = ['Android', 'iPhone', 'iPad'];
